    import React, { useEffect, useState } from 'react';
    import axios from 'axios';
    import ActionBar from '../../../Components/Button/ActionBar';
    import TicketPriceForm2 from '../../../Components/Forms/TicketGroupForm2';
    import { useLocation } from 'react-router-dom';

    export default function TicketPricesEditor() {
        const location = useLocation();
        const ticketGroupCode = location.state?.ticketGroupCode;
        const [role, setRole] = useState<string | null>(null);
        const [isSubmitting, setIsSubmitting] = useState(false);

        const [ticket_group_code, setTicketGroupCode] = useState('');
        const [ticket_notes, setTicketNotes] = useState('');
        const [tier, setTier] = useState<string[]>(['']);
        const [currency, setCurrency] = useState('');
        const [amount, setAmount] = useState<string[]>(['']);
        const [tier_id, setTierID] = useState<string[]>(['']);

        const handleTicketGroupCodeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
            setTicketGroupCode(e.target.value);
        };

        const handleTicketNotesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            setTicketNotes(e.target.value);
        };

        const handleTierChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
            const newTier = [...(tier || [])];
            newTier[index] = e.target.value;
            setTier(newTier);
        };

        const handleCurrencyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            setCurrency(e.target.value);
        };

        const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
            const newAmount = [...(amount || [])];
            newAmount[index] = e.target.value;
            setAmount(newAmount);
        };

        const handleAddMore = () => {
            setTier([...tier, '']);
            setAmount([...amount, '']);
            setTierID([...tier_id, '']);
        };

        const handleRemove = (index:number) =>{
            const updatedTier = tier.filter((_, i) => i !== index);
            const updatedAmount = amount.filter((_, i) => i !== index);
            const updatedTierID = tier_id.filter((_, i) => i !== index);
            setTier(updatedTier);
            setAmount(updatedAmount);
            setTierID(updatedTierID);
        };

        const fetchItem = async (code: string) => {
            try {
                const response = await axios.get(`https://stagingbackend.pulp.ph/api/v1/pulpliveworld/ticket-group-code/${code}`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                    },
                });

                const ticketGroup = response.data.ticketGroup;
                console.log('Response:', ticketGroup);
                
                if (ticketGroup && ticketGroup.length > 0) {
                    const fetchedTiers = ticketGroup.map((group: any) => group.tier || '');
                    const fetchedAmounts = ticketGroup.map((group: any) => group.amount || '');
                    const fetchedTierIDs = ticketGroup.map((group: any) => group.id || '');
                    setTier(fetchedTiers);
                    setAmount(fetchedAmounts);
                    setTierID(fetchedTierIDs);
                }
            } catch (error) {
                console.error('Error fetching item:', error);
            }
        };

        const handleSubmit = async (e: React.FormEvent) => {
            e.preventDefault();
            setIsSubmitting(true);
        };

        useEffect(() => {
            if (ticketGroupCode) {
                fetchItem(ticketGroupCode);
            }
        }, [ticketGroupCode]);

        useEffect(() => {
            const storedRole = localStorage.getItem('role');
            setRole(storedRole);
        }, []);

        return (
            <div className="w-full p-5">
                <div className="flex justify-between items-center mb-4">
                    <h1 className="GraphikSemibold text-[20px] font-semibold">Ticket Prices Editor</h1>
                    <ActionBar
                        role={role}
                        onSubmit={handleSubmit}
                        isSubmitting={isSubmitting}
                        isSaved={isSubmitting}
                    />
                </div>

                <div className="container mt-3 py-5 px-4 rounded bg-white">
                    <TicketPriceForm2
                        ticket_group_code={ticket_group_code}
                        ticket_notes={ticket_notes}
                        tier={tier}
                        currency={currency}
                        amount={amount}
                        tier_id={tier_id} 
                        onTicketGroupCodeChange={handleTicketGroupCodeChange}
                        onTicketNotesChange={handleTicketNotesChange}
                        onTierChange={handleTierChange}
                        onCurrencyChange={handleCurrencyChange}
                        onAmountChange={handleAmountChange}
                        onAddMore={handleAddMore}
                        onDelete={handleRemove}
                    />
                </div>
            </div>
        );
    }
